import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const PatientManagement = ({
    activeMenu = ''
}) => {
    const location = useLocation();
    const patientData = location.state || {};
    
    // Función para construir las URLs con los datos del paciente
    const buildPatientUrl = (path) => {
        return {
            pathname: path,
            state: {
                patientId: patientData.patientId,
                patientName: patientData.patientName,
                patientDob: patientData.patientDob,
                patientEmail: patientData.patientEmail,
                patientPhone: patientData.patientPhone,
            }
        };
    };

    return (
        <div className="inner-menu-container bg-white shadow-sm">
            <div className="container-fluid px-lg-3">
                

                <ul className="nav secondary-menu mw-100 flex-nowrap gap-1 gap-sm-2 gap-lg-3 flex-fill fs-sm fw-semibold text-center border-0 text-nowrap overflow-auto">
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-appointments")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'appointments' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Appointments
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-prescriptions")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'prescriptions' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Prescriptions
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-conditions")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'conditions' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Conditions
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-medications")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'medications' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Medications
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-allergies")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'allergies' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Allergies
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-immunizations")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'immunizations' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Immunizations
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-results")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'results' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Results
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-vitals")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'vitals' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Vitals
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-electronic-prescriptions")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'electronic-prescriptions' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Electronic Prescriptions
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-orders")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'orders' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Orders
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-consents")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'consent' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Consent
                        </Link>
                    </li>
                    <li className="nav-item flex-fill">
                        <Link 
                            to={buildPatientUrl("/my-profile-settings")}
                            className={`d-block px-1 px-sm-2 py-2 py-sm-3 position-relative text-decoration-none ${
                                activeMenu === 'settings' 
                                    ? 'text-primary' 
                                    : 'text-black'
                            }`}
                        >
                            Settings
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default PatientManagement;